module.exports = __webpack_public_path__ + "img/new_square_code.b1ff5ff4.png";